module.exports = __webpack_public_path__ + "img/hongdou.7e9c06e8.png";